import { OperatorData, OperatorDefinition } from '../../types';

export const Null: OperatorDefinition = {
  schema: {},
};
